'use client';

import { SessionProvider } from 'next-auth/react';
import { useEffect } from 'react';
import { signOut } from 'next-auth/react';

function CrossTabLogoutListener() {
  useEffect(() => {
    const handleStorageChange = (event: StorageEvent) => {
      // Listen for cross-tab logout events
      if (event.key === 'logout-event') {
        // Another tab logged out, sign out this tab too
        signOut({ callbackUrl: '/', redirect: true });
      }
    };

    window.addEventListener('storage', handleStorageChange);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  return null;
}

export function UserSessionProviders({ children }: { children: React.ReactNode }) {
  return (
    <SessionProvider>
      <CrossTabLogoutListener />
      {children}
    </SessionProvider>
  );
} 